export default "__VITE_ASSET__Dp$Kq8JW__"